// extracted by mini-css-extract-plugin
export default {"button":"rl-z","reviewSort":"sl-z"};